import { DataButton } from "@sellar-io/components";
import { TableInputContainer } from "../../../../components/tableInputContainer/TableInputContainer";
import { twMerge } from "tailwind-merge";
import { useInvoicesFilterStore } from "../stores/InvoicesFilterStore";

import { useShallow } from "zustand/react/shallow";
import { InputSelect, InputOption } from "@sellar-io/components";
import { useState } from "react";
import {
  InvoiceStatusEnumType,
  InvoiceTypeEnumType,
} from "@sellar-io/api-v2/types";

export const InvoicesFilter = ({
  onDismiss,
  isMobile,
}: {
  onDismiss: () => void;
  isMobile?: boolean;
}) => {
  const state = useInvoicesFilterStore(useShallow((state) => state));

  const [status, setStatus] = useState<InvoiceStatusEnumType | "all">(
    state.status,
  );
  const [type, _setType] = useState<InvoiceTypeEnumType | "all">(state.type);

  const filtersApplied = state.status !== "all" || state.type !== "all";
  const disabled = status === "all" && type === "all";

  const onApply = (reset: boolean) => {
    if (reset) {
      useInvoicesFilterStore.getState().reset();
    } else {
      useInvoicesFilterStore.getState().setState({
        ...state,
        status,
        type,
      });
    }
    onDismiss();
  };

  return (
    <div>
      <div
        className={twMerge(
          "w-full",
          isMobile ? "px-4 pt-2" : "border-b border-zinc-300 p-4",
        )}
      >
        <span className="font-semibold">Filter invoices</span>
      </div>
      <div className="w-full p-4">
        <div className="flex flex-col gap-3">
          {/* invoice status filter */}
          <div className="flex w-full items-center justify-between gap-3">
            <div className="flex shrink-0">Status</div>
            <div className="w-[55%]">
              <TableInputContainer>
                <InputSelect
                  defaultValue={state.status}
                  onChange={(e: {
                    target: { value: string | InvoiceStatusEnumType };
                  }) => {
                    const value = e.target.value;
                    const invoiceStatus = (
                      value.length ? value : null
                    ) as InvoiceStatusEnumType;
                    setStatus(invoiceStatus);
                  }}
                  className="text-sm font-medium"
                >
                  <InputOption value={"all"}>All</InputOption>
                  <InputOption value={"draft"}>Draft</InputOption>
                  <InputOption value={"issued"}>Issued</InputOption>
                  <InputOption value={"payment_processing"}>
                    Payment processing
                  </InputOption>
                  <InputOption value={"paid"}>Paid</InputOption>
                  <InputOption value={"void"}>Void</InputOption>
                </InputSelect>
              </TableInputContainer>
            </div>
          </div>

          {/* invoice "type" filter */}
          {/* TODO: bring this back in when we have more than one type */}
          {/* <div className="flex w-full items-center justify-between gap-3">
            <div className="flex shrink-0">Fee</div>
            <div className="w-[55%]">
              <TableInputContainer>
                <InputSelect
                  defaultValue={state.type ?? "all"}
                  onChange={(e) => {
                    const value = e.target.value;
                    const invoiceType = (
                      value.length ? value : null
                    ) as InvoiceTypeEnumType;
                    setType(invoiceType);
                  }}
                  className="text-sm font-medium"
                >
                  <InputOption value={"all"}>All</InputOption>
                  <InputOption value={"openingOrderFees"}>OOF</InputOption>
                  <InputOption value={"sellarCreditRetailer"}>
                    Credit buyer
                  </InputOption>
                  <InputOption value={"sellarCreditSupplier"}>
                    Credit supplier
                  </InputOption>
                </InputSelect>
              </TableInputContainer>
            </div>
          </div> */}
        </div>
      </div>
      <div className="flex w-full items-center gap-2 p-4">
        <DataButton
          onClick={() => onApply(false)}
          border={true}
          disabled={disabled}
        >
          {"Apply"}
        </DataButton>
        {!!filtersApplied && (
          <DataButton color="transparent" onClick={() => onApply(true)}>
            Clear all
          </DataButton>
        )}
      </div>
    </div>
  );
};
